export class Constants {
  static Actions = [
    'None',
    'Add',
    'Delete',
    'Edit',
    'Cancel',
    'SendForAssignment',
    'ChangeAssignment',
    'Park',
    'SentToUserGroup',
    'Complete',
    'Reset',
    'Approved',
    'Rejected',
    'Audited',
    'StaffAllocated',
    'Start',
    'Pause',
    'RecordMetric',
    'ScheduleTrigger',
    'ManualTrigger',
    'DependentTrigger ',
    'SentForFrontOfficeApproval',
  ];

  static AuditColumns: string[] = [
    'EntityCode',
    'ActionName',
    'CreatedByStaffName',
    'CreatedOn',
  ];

  static MetricColumns: string[] = ['Name', 'MetricTypeName', 'Unit', 'Action'];

  static UserGroupColumns: string[] = ['Name', 'Action'];

  static UILabels = {
    NoApproval: 'LBL.NO_APPROVAL',
    FrontOffice: 'LBL.FRONT_OFFICE',
    UserGroup: 'LBL.USER_GROUP',
    OverrideAssetSetting: 'LBL.OVERRIDE_ASSET_SETTING',
    UseAssetSetting: 'LBL.USE_ASSET_SETTING',
    None: 'LBL.NONE',
    Pattern: 'LBL.PATTERN',
    FixedDates: 'LBL.FIXED_DATES',
    Gap: 'LBL.SCHEDULE_GAP',
    Active: 'LBL.ACTIVE',
    Deleted: 'LBL.DELETED',
    Disabled: 'LBL.DISABLED',
    Maintenance: 'LBL.MAINTENANCE',
    Checklist: 'LBL.CHECKLIST',
    Tasklist: 'LBL.TASKLIST',
    MeterBased: 'LBL.METER_BASED',
    Audit: 'LBL.AUDIT',
    CheckUp: 'LBL.CHECK_UP',
    CheckDown: 'LBL.CHECK_DOWN',
    NotApproved: 'LBL.NOT_APPROVED',
    Approved: 'LBL.APPROVED',
    Rejected: 'LBL.REJECTED',
    EditChecklist: 'LBL.EDIT_CHECKLIST',
    EditChecklistItems: 'LBL.EDIT_CHECKLIST_ITEMS',
    NewChecklist: 'LBL.NEW_CHECKLIST',
    NewChecklistItems: 'LBL.NEW_CHECKLIST_ITEMS',
    EditTask: 'LBL.EDIT_TASK',
    NewTask: 'LBL.NEW_TASK',
    EditTasklist: 'LBL.EDIT_TASKLIST',
    NewTasklist: 'LBL.NEW_TASKLIST',
    EditMetric: 'LBL.EDIT_METRIC',
    NewMetric: 'LBL.NEW_METRIC',
    EditAssetCategory: 'LBL.EDIT_ASSET_CATEGORY',
    NewAssetCategory: 'LBL.NEW_ASSET_CATEGORY',
    EditUserGroup: 'LBL.EDIT_USER_GROUP',
    NewUserGroup: 'LBL.NEW_USER_GROUP',
    NewAsset: 'LBL.NEW_ASSET',
    EditAsset: 'LBL.EDIT_ASSET',
    EditPM: 'LBL.EDIT_PM',
    NewPM: 'LBL.NEW_PM',
    ClonePM: 'LBL.CLONE_PM',
  };

  static DateFormat = {
    TABLE_DATETIME: 'dd MMM HH:mm',
    TABLE_DATE_DAY: 'dd MMM yyyy',
    TABLE_DATE_FULL: 'dd MMM yyyy HH:mm',
    TABLE_TIME: 'HH:mm',
  };

  static MAX_PAGE_SIZE = 1_00_000;

  static APP_ERRORS = {
    NullLocationIntersection: 'NullLocationIntersection',
  };
}
